import React from 'react'
import { useSelector } from 'react-redux';
import { SUBSCRIPTION_MODULE_TYPE } from '../../constants';

export default function CompanySteps({ selectedStep }) {
    const { stripePlans } = useSelector((state) => state.stripe);

    return (
        <div className="row indicatorSectionMain">
            <div className="col-3 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineLeft">
                    {selectedStep >= 2 ? <img src="assets/img/steptick.svg" alt="" srcSet="" /> : <div className="Iconcircle IconcircleActive"></div>
                    }
                    <div className={`ConnectLineLeft ${selectedStep >= 2 ? 'ConnectLineActive' : ""}`}></div>
                </div>
                <p className="indicatorSectiondiv indicatorSectiondivActive">Start a holding company</p>
            </div>
            <div className="col-3 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineCenter">
                    <div className={`ConnectLineLeft ${selectedStep >= 2 ? 'ConnectLineActive' : ""}`}></div>
                    {selectedStep >= 3 ? <img src="assets/img/steptick.svg" alt="" srcSet="" /> : <div className={`Iconcircle ${selectedStep >= 2 ? 'IconcircleActive' : ""}`}></div>}
                    <div className={`ConnectLineLeft ${selectedStep >= 3 ? 'ConnectLineActive' : ""}`}></div>
                </div>
                <p className="indicatorSectiondiv">Add business activities</p>
            </div>
            <div className="col-3 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineRight">
                    <div className={`ConnectLineLeft ${selectedStep >= 3 ? 'ConnectLineActive' : ""}`}></div>
                    {selectedStep >= 4 ? <img src="assets/img/steptick.svg" alt="" srcSet="" /> : <div className={`Iconcircle ${selectedStep >= 3 ? 'IconcircleActive' : ""}`}></div>}
                      <div className={`ConnectLineLeft ${selectedStep >= 4 ? 'ConnectLineActive' : ""}`}></div>
                </div>
                <p className="indicatorSectiondiv">Add objective</p>
            </div>
               <div className="col-3 p-0 indicatorSection">
                <div className="indicatorCircelLine indicatorCircelLineRight">
                    <div className={`ConnectLineLeft ${selectedStep >= 4 ? 'ConnectLineActive' : ""}`}></div>
                    {selectedStep >= 5 ? <img src="assets/img/steptick.svg" alt="" srcSet="" /> : <div className={`Iconcircle ${selectedStep >= 4 ? 'IconcircleActive' : ""}`}></div>}
                </div>
                <p className="indicatorSectiondiv">Verify your business</p>
            </div>
        </div>
    )
}
